import React, { useContext, useState } from 'react';
import { AudioContext } from '../../libs/audio-provider';
import Modal from '../ui/Modal';
import SvgButton from '../ui/SvgButton';

interface GameCompassHintsAndDescriptionModalProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

function GameCompassHintsAndDescriptionModal(_props: GameCompassHintsAndDescriptionModalProps) {
  const { playClick } = useContext(AudioContext);
  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      <div className="lives-and-hints">
        <button className="hints-button" onClick={() => { playClick(); setModalShow(true) }}>  </button>
        {modalShow
          ? <Modal>
            <div className="modal modal-game-compass game-description">
              <button className="button modal-button-close" onClick={() => { playClick(); setModalShow(false) }}>
                <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/game-compass/close-button`} src1=".svg" src2="-select.svg" alt="關閉"></SvgButton>
              </button>
              <div className="modal-content">
                <p>進入遊戲畫面後，會顯示船隻及羅盤指針‧<br/>同學需要控制羅盤，點擊東南西北‧<br/>找出正確的航海方位‧</p>
              </div>
            </div>
          </Modal>
          : null}
      </div>
    </>
  );
}

export default GameCompassHintsAndDescriptionModal;
